import { getToken } from "firebase/messaging";
import { messaging } from "./auth";

export const VAPID_KEY =
  "BCCKKKKvLH3rLxXyd-Xa5wnHftvzDwOrOOPLGubuhHzQ_oBZxkshZV0-OqKKXOD3nzH8OY5BgSkh8BS81iVX-aI";

export async function getFcmToken() {
  try {
    const permission = await Notification.requestPermission();
    console.log("FCM permission:", permission);
    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    console.log("FCM token:", token);

    return token;
  } catch (error) {
    console.error("Error getting token", error);
    return null;
  }
}
